<template>
    <div class="Information">
        <dic class="container-fluid">
            <div class="row">
                <div class="col-md-4">
                    <div class="record-section">
                        <h4>Name</h4>
                        <p>
                            <span class="bold">First Name: </span>
                            <StringEditor v-bind:old-value="ChildRecordData.Client.Person.FirstName"
                                          v-bind:record-id="ChildRecordData.Client.Person.Id"
                                          v-bind:edit-mode="EditMode"
                                          data-label="First Name"
                                          property-name="FirstName"
                                          update-method="Core/Person/Update"
                                          v-bind:required="true"
                                          :chart-id="ChildRecordData.Id" />
                        </p>
                        <p>
                            <span class="bold">AKA: </span>
                            <StringEditor v-bind:old-value="ChildRecordData.Client.Person.AKA"
                                          v-bind:record-id="ChildRecordData.Client.Person.Id"
                                          v-bind:edit-mode="EditMode"
                                          data-label="AKA"
                                          property-name="AKA"
                                          update-method="Core/Person/Update"
                                          v-bind:required="false"
                                          :chart-id="ChildRecordData.Id" />
                        </p>
                        <p>
                            <span class="bold">Middle Name: </span>
                            <StringEditor v-bind:old-value="ChildRecordData.Client.Person.MiddleName"
                                          v-bind:record-id="ChildRecordData.Client.Person.Id"
                                          v-bind:edit-mode="EditMode"
                                          data-label="Middle Name"
                                          property-name="MiddleName"
                                          update-method="Core/Person/Update"
                                          v-bind:required="false"
                                          :chart-id="ChildRecordData.Id" />
                        </p>
                        <p>
                            <span class="bold">Last Name: </span>
                            <StringEditor v-bind:old-value="ChildRecordData.Client.Person.LastName"
                                          v-bind:record-id="ChildRecordData.Client.Person.Id"
                                          v-bind:edit-mode="EditMode"
                                          data-label="Last Name"
                                          property-name="LastName"
                                          update-method="Core/Person/Update"
                                          required="true"
                                          :chart-id="ChildRecordData.Id" />
                        </p>
                        <p>
                            <span class="bold">Suffix: </span>
                            <StringEditor v-bind:old-value="ChildRecordData.Client.Person.Suffix"
                                          v-bind:record-id="ChildRecordData.Client.Person.Id"
                                          v-bind:edit-mode="EditMode"
                                          data-label="Suffix"
                                          property-name="Suffix"
                                          update-method="Core/Person/Update"
                                          required="false"
                                          :chart-id="ChildRecordData.Id" />
                        </p>
                        <p>
                            <span class="bold">Previous First Name: </span>
                            <StringEditor v-bind:old-value="ChildRecordData.Client.Person.FirstNamePrevious"
                                          v-bind:record-id="ChildRecordData.Client.Person.Id"
                                          v-bind:edit-mode="EditMode"
                                          data-label="First Name Previous"
                                          property-name="FirstNamePrevious"
                                          update-method="Core/Person/Update"
                                          required="false"
                                          :chart-id="ChildRecordData.Id" />
                        </p>
                        <p>
                            <span class="bold">Previous Last Name: </span>
                            <StringEditor v-bind:old-value="ChildRecordData.Client.Person.LastNamePrevious"
                                          v-bind:record-id="ChildRecordData.Client.Person.Id"
                                          v-bind:edit-mode="EditMode"
                                          data-label="Last Name Previous"
                                          property-name="LastNamePrevious"
                                          update-method="Core/Person/Update"
                                          required="false"
                                          :chart-id="ChildRecordData.Id" />
                        </p>
                        <p>
                            <span class="bold">Date Name Changed: </span>
                            <DateEditor v-bind:old-value="ChildRecordData.Client.Person.NameChangeDate"
                                        v-bind:record-id="ChildRecordData.Client.Person.Id"
                                        v-bind:edit-mode="EditMode"
                                        data-label="Name Change Date"
                                        property-name="NameChangeDate"
                                        update-method="Core/Person/Update"
                                        :global-update="true"
                                        :chart-id="ChildRecordData.Id" />
                        </p>
                    </div>
                    
                </div>
                <div class="col-md-4">
                    <div class="record-section">
                        <h4>Personal Info</h4>
                        <p>
                            <span class="bold">DOB: </span>
                            <DateEditor v-bind:old-value="ChildRecordData.Client.Person.DOB"
                                        v-bind:record-id="ChildRecordData.Client.Person.Id"
                                        v-bind:edit-mode="EditMode"
                                        data-label="DOB"
                                        property-name="DOB"
                                        update-method="Core/Person/Update"
                                        required="true"
                                        :global-update="true"
                                        :chart-id="ChildRecordData.Id"
                                        edit-permission="Wraparound.ClientInfo.Edit" />
                        </p>
                        <p>
                            <span class="bold">Client Personal Phone #: </span>
                            <StringEditor v-bind:old-value="PersonalPhoneNumber"
                                          v-bind:record-id="ChildRecordData.Client.Person.Id"
                                          v-bind:edit-mode="EditMode"
                                          data-label="Client Personal Phone #"
                                          property-name="PhoneNumber"
                                          update-method="Core/Person/Update"
                                          :chart-id="ChildRecordData.Id" />
                        </p>
                        <p>
                            <span class="bold">SSN: </span>
                            <StringEditor v-bind:old-value="ChildRecordData.Client.Person.SSN"
                                          v-bind:record-id="ChildRecordData.Client.Person.Id"
                                          v-bind:edit-mode="EditMode"
                                          data-label="SSN"
                                          property-name="SSN"
                                          update-method="Core/Person/Update"
                                          :chart-id="ChildRecordData.Id" />
                        </p>
                        <p>
                            <span class="bold">CID: </span>
                            <StringEditor v-bind:old-value="ChildRecordData.Client.CID"
                                          v-bind:record-id="ChildRecordData.Client.Id"
                                          v-bind:edit-mode="EditMode"
                                          data-label="State ID"
                                          property-name="CID"
                                          update-method="Clients/UpdateCID"
                                          v-bind:required="false"
                                          :chart-id="ChildRecordData.Id" />
                        </p>
                        <p>
                            <span class="bold">WelligentID: </span>
                            <StringEditor v-bind:old-value="ChildRecordData.Client.WelligentID"
                                          v-bind:record-id="ChildRecordData.Client.Id"
                                          v-bind:edit-mode="EditMode"
                                          data-label="Welligent ID"
                                          property-name="WelligentID"
                                          update-method="Clients/UpdateWelligentID"
                                          v-bind:required="false"
                                          edit-permission="Wraparound.ClientInfo.Edit.Welligent"
                                          :chart-id="ChildRecordData.Id" />
                        </p>
                    </div>
                    
                </div>
                <div class="col-md-4">
                    <div class="record-section">
                        <h4>Demographics</h4>
                        <p>
                            <span class="bold">Sex: </span>
                            <SelectEditor v-bind:old-value="ChildRecordData.Client.Person.SexID"
                                          v-bind:old-value-text="ChildRecordData.Client.Person.Sex.Name"
                                          v-bind:record-id="ChildRecordData.Client.Person.Id"
                                          v-bind:edit-mode="EditMode"
                                          data-label="Sex"
                                          property-name="SexID"
                                          update-method="Core/Person/Update"
                                          required="true"
                                          v-bind:options="SexOptions"
                                          :chart-id="ChildRecordData.Id" />
                        </p>
                        <p>
                            <span class="bold">Race: </span>
                            <SelectEditor v-bind:old-value="ChildRecordData.Client.Person.RaceID"
                                          v-bind:old-value-text="ChildRecordData.Client.Person.Race.Name"
                                          v-bind:record-id="ChildRecordData.Client.Person.Id"
                                          v-bind:edit-mode="EditMode"
                                          data-label="Race"
                                          property-name="RaceID"
                                          update-method="Core/Person/Update"
                                          required="true"
                                          v-bind:options="RaceOptions"
                                          :chart-id="ChildRecordData.Id" />
                        </p>
                        <p>
                            <span class="bold">Ethnicity: </span>
                            <SelectEditor v-bind:old-value="ChildRecordData.Client.Person.EthnicityID"
                                          v-bind:old-value-text="ChildRecordData.Client.Person.Ethnicity.Name"
                                          v-bind:record-id="ChildRecordData.Client.Person.Id"
                                          v-bind:edit-mode="EditMode"
                                          data-label="Ethnicity"
                                          property-name="EthnicityID"
                                          update-method="Core/Person/Update"
                                          required="true"
                                          v-bind:options="EthnicityOptions"
                                          :chart-id="ChildRecordData.Id" />
                        </p>
                    </div>
                    
                </div>
            </div>
        </dic>
        
        <EditMode :EditMode="EditMode" @update-edit-mode="UpdateEditMode" permission="Wraparound.ClientInfo.Edit"/>
    </div>
</template>

<script>
    //import icons
    import { library } from '@fortawesome/fontawesome-svg-core';
    import { faEdit } from '@fortawesome/free-solid-svg-icons';
    library.add(faEdit);
    //import components
    import StringEditor from '../../../Core/ItemEditors/StringEditor';
    import DateEditor from '../../../Core/ItemEditors/DateEditor';
    import SelectEditor from '../../../Core/ItemEditors/SelectEditor';
    import PersonEditor from '../../../Core/ItemEditors/PersonEditor';
    import EditMode from '../../../Core/ItemEditors/EditMode.vue';
    export default {
        props: [
            'ChildRecordData'
        ],
        data: function () {
            return {
                EditMode: false
            };
        },
        methods: {
            formatDate(value, fmt = 'MM/DD/YY', defaultText = '') {
                return (value == null)
                    ? defaultText
                    : moment(value, 'YYYY-MM-DD').format(fmt)
            },
            UpdateEditMode() {
                this.EditMode = !this.EditMode;
            },
        },
        components: {
            StringEditor,
            DateEditor,
            SelectEditor,
            PersonEditor,
            EditMode
        },
        mounted() {

        },
        computed: {
            SexOptions: function () {
                return this.$store.state.Options.Sexes;
            },
            RaceOptions: function () {
                return this.$store.state.Options.Races;
            },
            EthnicityOptions: function () {
                return this.$store.state.Options.Ethnicities;
            },
            PersonalPhoneNumber: function () {
                if (this.ChildRecordData.Client.Person.PhoneNumbers.length > 0) {
                    return this.ChildRecordData.Client.Person.PhoneNumbers[0].PhoneNumber.FormattedPhoneNumber;
                } else {
                    return "";
                }
            }
        }
    }
</script>

<style scoped>
</style>